/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The PaperSectionCreateForm model module.
   * @module course_standard/model/PaperSectionCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PaperSectionCreateForm</code>.
   * @alias module:course_standard/model/PaperSectionCreateForm
   * @class
   * @param paperId {Integer} paper id
   * @param name {String} 名称
   * @param drillType {Integer} 题目类型
   * @param subType {Integer} 题目子类型
   * @param quantity {Integer} 总题数
   * @param itemScore {Number} 每题分值
   */
  var exports = function(paperId, name, drillType, subType, quantity, itemScore) {
    var _this = this;

    _this['paperId'] = paperId;

    _this['name'] = name;

    _this['drillType'] = drillType;
    _this['subType'] = subType;
    _this['quantity'] = quantity;
    _this['itemScore'] = itemScore;
  };

  /**
   * Constructs a <code>PaperSectionCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/PaperSectionCreateForm} obj Optional instance to populate.
   * @return {module:course_standard/model/PaperSectionCreateForm} The populated <code>PaperSectionCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'paperId')) {
        obj['paperId'] = ApiClient.convertToType(data['paperId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'directions')) {
        obj['directions'] = ApiClient.convertToType(data['directions'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'drillType')) {
        obj['drillType'] = ApiClient.convertToType(data['drillType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subType')) {
        obj['subType'] = ApiClient.convertToType(data['subType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'quantity')) {
        obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'itemScore')) {
        obj['itemScore'] = ApiClient.convertToType(data['itemScore'], 'Number');
      }
    }
    return obj;
  }

  /**
   * paper id
   * @member {Integer} paperId
   */
  exports.prototype['paperId'] = undefined;
  /**
   * 排序
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 题目指令
   * @member {String} directions
   */
  exports.prototype['directions'] = undefined;
  /**
   * 题目类型
   * @member {Integer} drillType
   */
  exports.prototype['drillType'] = undefined;
  /**
   * 题目子类型
   * @member {Integer} subType
   */
  exports.prototype['subType'] = undefined;
  /**
   * 总题数
   * @member {Integer} quantity
   */
  exports.prototype['quantity'] = undefined;
  /**
   * 每题分值
   * @member {Number} itemScore
   */
  exports.prototype['itemScore'] = undefined;



  export default exports;
;


